/**
 * axios配置
 */
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import store from '@/store';
import router from '@/router';
import setting from './setting';
import { MessageBox } from 'element-ui';

Vue.use(VueAxios, axios);

axios.defaults.baseURL = setting.baseURL;
axios.defaults.headers.common[setting.tokenHeaderName] = store.state.user.token;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

/* 响应拦截器 */
axios.interceptors.response.use(
  (res) => {
    // console.log(res);
    if (res.data.resCode == 401) {
      // 登录过期处理
      MessageBox.alert('登录状态已过期，请退出重新登录！', '系统提示', {
        confirmButtonText: '重新登录',
        callback: (action) => {
          if (action === 'confirm') {
            store.dispatch('user/setToken').then(() => {
              router.push({ path: '/login' });
            });
          }
        },
        beforeClose: () => {
          MessageBox.close();
        },
      });
      return Promise.reject(new Error(res.data.resMsg));
    }
    if (res.data.resCode == 1002) {
      MessageBox.alert('当前无操作权限，请联系管理员进行核实！');
      return Promise.reject(new Error(res.data.resMsg));
    }
    // token自动续期0
    let access_token = res.headers[setting.tokenReponseName];
    if (access_token) store.dispatch('user/setToken', access_token);
    return res;
  },
  (error) => {
    console.log(error);
    MessageBox.alert(error.message, '系统提示');
    return Promise.reject(error);
  }
);

export default axios;
